import { useState, useEffect } from "react";
import { base44 } from "@/api/base44Client";

/**
 * Fetches guaranteed-placement product records for the given outlet names in a
 * single query, returning an object map keyed by record name. Used by the /uae
 * and /mena Named-outlets walls so every card field (brand logo, DA, link type,
 * retail price, Tier 1 flag) reads live from the catalogue.
 *
 * While loading or if the fetch fails, the map is empty; callers render the
 * text-name fallback and no price for any name not yet present.
 */
export function useOutletRecords(names) {
  const [records, setRecords] = useState({});
  const key = (names || []).join("|");

  useEffect(() => {
    if (!names || names.length === 0) return;
    base44.entities.Package.filter(
      {
        category: "guaranteed_placements",
        is_active: true,
        retail_visible: { $ne: false },
        name: { $in: names },
      },
      "-domain_authority",
      50
    )
      .then((res) => {
        const map = {};
        (res || []).forEach((p) => {
          if (p && p.name) map[p.name] = p;
        });
        setRecords(map);
      })
      .catch(() => {
        setRecords({});
      });
  }, [key]);

  return records;
}